
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';
import Seo from '@/components/Seo';
export default function VerifyEmail() {
    const router = useRouter();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    // Get query parameters
    const { token_hash, type, next } = router.query;
    // Convert to strings (router.query values can be string | string[] | undefined)
    const tokenHash = Array.isArray(token_hash)
        ? token_hash[0]
        : token_hash || '';
    const verifyType = Array.isArray(type) ? type[0] : type || '';
    const nextUrl = Array.isArray(next) ? next[0] : next || '/dashboard';
    const handleClick = () => {
        if (!tokenHash || !verifyType) {
            setError('Invalid verification link. Please try signing up again.');
            return;
        }
        setIsRedirecting(true);
        // Redirect to the actual confirmation endpoint
        const confirmUrl = new URL('/auth/confirm', window.location.origin);
        confirmUrl.searchParams.set('token_hash', tokenHash);
        confirmUrl.searchParams.set('type', verifyType);
        confirmUrl.searchParams.set('next', nextUrl);
        window.location.href = confirmUrl.toString();
    };
    // Auto-click after a short delay to give users time to see the page
    useEffect(() => {
        if (tokenHash && verifyType && router.isReady) {
            const timer = setTimeout(() => {
                handleClick();
            }, 1500); // 1.5 second delay
            return () => clearTimeout(timer);
        }
    }, [tokenHash, verifyType, router.isReady]);
    if (error) {
        return (<div className='flex min-h-screen items-center justify-center dark:bg-slate-900'>
        <Seo templateTitle='Verification Error'/>
        <div className='w-full max-w-md px-4'>
          <div className='text-center'>
            <div className='mb-6 p-4 rounded-md bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-400'>
              {error}
            </div>
            <Link href='/login#auth-sign-up' className='inline-block rounded-md border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2'>
              Back to Sign Up
            </Link>
          </div>
        </div>
      </div>);
    }
    return (<div className='flex min-h-screen items-center justify-center dark:bg-slate-900'>
      <Seo templateTitle={verifyType === 'recovery' ? 'Reset Password' : 'Verify Email'}/>
      <div className='w-full max-w-md px-4'>
        <div className='text-center'>
          <Link href='/' className='' passHref legacyBehavior>
            <span className='flex justify-center text-2xl font-extrabold text-primary-700 mb-6 cursor-pointer'>
              <Image src='/images/marky.png' width='250' height='36' alt='Easy-Peasy.ai logo'/>
            </span>
          </Link>

          <h1 className='text-3xl font-bold mb-4 text-gray-900 dark:text-slate-200'>
            {verifyType === 'recovery'
            ? 'Reset Your Password'
            : 'Verify Your Email'}
          </h1>

          <p className='text-gray-600 dark:text-slate-400 mb-8'>
            {verifyType === 'recovery'
            ? 'Click the button below to continue with resetting your password.'
            : 'Click the button below to complete your sign-in process.'}
          </p>

          {isRedirecting ? (<div className='py-6'>
              <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4'></div>
              <p className='text-sm text-gray-600 dark:text-slate-400'>
                Verifying your{' '}
                {verifyType === 'recovery' ? 'reset link' : 'email'}...
              </p>
            </div>) : (<div className='w-full'>
              <button onClick={handleClick} className='w-full py-3 px-4 text-lg rounded-md border border-transparent bg-primary-600 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-colors'>
                {verifyType === 'recovery'
                ? 'Continue to Reset Password'
                : 'Confirm Email'}
              </button>

              <p className='mt-4 text-xs text-gray-500 dark:text-gray-400'>
                You will be automatically redirected in a moment...
              </p>
            </div>)}

          <div className='mt-8 text-sm text-gray-600 dark:text-slate-400'>
            <p>Having trouble?</p>
            <Link href={verifyType === 'recovery'
            ? '/auth/forgot-password'
            : '/login#auth-sign-up'} className='text-primary-600 hover:text-primary-500 dark:text-primary-400'>
              {verifyType === 'recovery'
            ? 'Request a new reset link'
            : 'Try signing up again'}
            </Link>
          </div>
        </div>
      </div>
    </div>);
}

    async function __Next_Translate__getStaticProps__1a15314ea6a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/auth/verify',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15314ea6a__ as getStaticProps }
  